/* ==========================================================================
   Git Config Generator — Vanilla JS
   ========================================================================== */

(function () {
  'use strict';

  /* ── Data ─────────────────────────────────────────────────────────── */

  var CONFIG_SECTIONS = {
    identity: {
      label: 'Identity',
      icon: '👤',
      description: 'Who you are in every commit',
      settings: [
        { key: 'user.name', label: 'Your Name', type: 'text', placeholder: 'Jane Developer', help: 'Shown in commit author field' },
        { key: 'user.email', label: 'Your Email', type: 'text', placeholder: 'jane@example.com', help: 'Shown in commit author field' }
      ]
    },
    core: {
      label: 'Core Behavior',
      icon: '⚙️',
      description: 'Fundamental Git behavior settings',
      settings: [
        { key: 'core.autocrlf', label: 'Line Endings', type: 'select', help: 'How Git handles line endings across OSes', defaultValue: 'false', options: [
          { value: 'false', label: 'No conversion (default)' },
          { value: 'true', label: 'Convert to CRLF on checkout (Windows)' },
          { value: 'input', label: 'Convert to LF on commit only (Mac/Linux)' }
        ]},
        { key: 'core.editor', label: 'Default Editor', type: 'select', help: 'Editor for commit messages, rebase, etc.', defaultValue: 'vim', options: [
          { value: 'vim', label: 'Vim (default)' },
          { value: 'code --wait', label: 'VS Code' },
          { value: 'cursor --wait', label: 'Cursor' },
          { value: 'nvim', label: 'Neovim' },
          { value: 'nano', label: 'Nano' },
          { value: 'emacs', label: 'Emacs' },
          { value: 'subl -n -w', label: 'Sublime Text' },
          { value: "'C:/Program Files/Notepad++/notepad++.exe' -multiInst -notabbar -nosession -noPlugin", label: 'Notepad++' }
        ]},
        { key: 'core.ignorecase', label: 'Ignore Filename Case', type: 'toggle', help: 'Useful on case-insensitive file systems (macOS, Windows)' },
        { key: 'core.whitespace', label: 'Whitespace Handling', type: 'select', help: 'Detect whitespace problems in diffs', defaultValue: 'trailing-space,space-before-tab', options: [
          { value: 'trailing-space,space-before-tab', label: 'Flag trailing spaces & spaces before tabs (default)' },
          { value: 'trailing-space,space-before-tab,indent-with-non-tab', label: 'Also flag indent with spaces (if using tabs)' },
          { value: '-trailing-space,-space-before-tab', label: 'Disable all whitespace checks' }
        ]},
        { key: 'init.defaultBranch', label: 'Default Branch Name', type: 'select', help: 'Name used for the initial branch when creating a new repository with git init', defaultValue: 'main', options: [
          { value: 'main', label: 'main (default)' },
          { value: 'master', label: 'master' },
          { value: 'trunk', label: 'trunk' },
          { value: 'develop', label: 'develop' }
        ]}
      ]
    },
    diff: {
      label: 'Diff, Merge & Rebase',
      icon: '🔀',
      description: 'How changes are displayed, conflicts resolved, and history rewritten',
      settings: [
        { key: 'diff.algorithm', label: 'Diff Algorithm', type: 'select', help: 'Algorithm for computing differences between files', defaultValue: 'myers', options: [
          { value: 'myers', label: 'Myers (default)' },
          { value: 'patience', label: 'Patience — better for large refactors' },
          { value: 'histogram', label: 'Histogram — fastest, great all-rounder' },
          { value: 'minimal', label: 'Minimal — smallest possible diff' }
        ]},
        { key: 'diff.colorMoved', label: 'Highlight Moved Lines', type: 'select', help: 'Color lines that were moved rather than changed', defaultValue: 'false', options: [
          { value: 'false', label: 'Off (default)' },
          { value: 'default', label: 'Default — color moved blocks' },
          { value: 'zebra', label: 'Zebra — alternating colors for adjacent blocks' },
          { value: 'dimmed-zebra', label: 'Dimmed Zebra — dim uninteresting moved code' }
        ]},
        { key: 'merge.conflictstyle', label: 'Merge Conflict Style', type: 'select', help: 'How merge conflicts are displayed in files', defaultValue: 'merge', options: [
          { value: 'merge', label: 'Merge — basic two-way (default)' },
          { value: 'diff3', label: 'Diff3 — shows base version too' },
          { value: 'zdiff3', label: 'ZDiff3 — cleaner diff3 output' }
        ]},
        { key: 'merge.tool', label: 'Merge Tool', type: 'select', help: 'External tool for resolving conflicts', defaultValue: 'none', options: [
          { value: 'none', label: 'None (default)' },
          { value: 'vscode', label: 'VS Code' },
          { value: 'vimdiff', label: 'Vimdiff' },
          { value: 'opendiff', label: 'FileMerge (macOS)' },
          { value: 'kdiff3', label: 'KDiff3' },
          { value: 'meld', label: 'Meld' }
        ]},
        { key: 'rerere.enabled', label: 'Reuse Recorded Resolution', type: 'toggle', help: 'Remember how you resolved a conflict and auto-apply it next time' },
        { key: 'rebase.autoSquash', label: 'Auto-Squash Fixups', type: 'toggle', help: 'Automatically reorder and squash commits prefixed with fixup! or squash! during interactive rebase' },
        { key: 'rebase.autoStash', label: 'Auto-Stash Before Rebase', type: 'toggle', help: "Automatically stash uncommitted changes before rebasing and re-apply them after — no more 'cannot rebase with dirty tree' errors" },
        { key: 'rebase.updateRefs', label: 'Update Stacked Branches on Rebase', type: 'toggle', help: 'When rebasing, automatically update branches that point to commits being rewritten — essential for stacked branch workflows' }
      ]
    },
    push_pull: {
      label: 'Push & Pull',
      icon: '🔄',
      description: 'Remote synchronization defaults',
      settings: [
        { key: 'push.default', label: 'Push Default', type: 'select', help: "What gets pushed when you run 'git push'", defaultValue: 'simple', options: [
          { value: 'simple', label: 'Simple — push to same-name upstream (default)' },
          { value: 'current', label: 'Current — push current branch to same-name remote' },
          { value: 'upstream', label: 'Upstream — push to the tracked upstream branch' }
        ]},
        { key: 'push.autoSetupRemote', label: 'Auto Setup Remote Tracking', type: 'toggle', help: 'Automatically set upstream when pushing a new branch' },
        { key: 'pull.rebase', label: 'Pull Strategy', type: 'select', help: 'What happens when you pull with remote changes', defaultValue: 'false', options: [
          { value: 'false', label: 'Merge — create a merge commit (default)' },
          { value: 'true', label: 'Rebase — replay your commits on top' },
          { value: 'interactive', label: 'Interactive Rebase — choose what to do' }
        ]},
        { key: 'fetch.prune', label: 'Auto-Prune on Fetch', type: 'toggle', help: 'Remove remote-tracking branches that no longer exist on the remote' },
        { key: 'fetch.prunetags', label: 'Auto-Prune Tags on Fetch', type: 'toggle', help: 'Remove tags that no longer exist on the remote' }
      ]
    },
    ui: {
      label: 'Colors & UI',
      icon: '🎨',
      description: 'Terminal output appearance',
      settings: [
        { key: 'color.ui', label: 'Colored Output', type: 'select', help: 'Enable color in Git terminal output', defaultValue: 'auto', options: [
          { value: 'auto', label: 'Auto — color when output is terminal (default)' },
          { value: 'always', label: 'Always — color even in pipes' },
          { value: 'false', label: 'Off — no color' }
        ]},
        { key: 'column.ui', label: 'Column Layout', type: 'select', help: 'Display some output in columns (e.g., branch list)', defaultValue: 'never', options: [
          { value: 'never', label: 'Off (default)' },
          { value: 'auto', label: 'Auto — columns when terminal is wide enough' },
          { value: 'always', label: 'Always' }
        ]},
        { key: 'log.abbrevCommit', label: 'Abbreviated Commits in Log', type: 'toggle', help: 'Show short commit hashes in git log by default' }
      ]
    },
    aliases: {
      label: 'Aliases',
      icon: '⌨️',
      description: 'Powerful shortcuts for complex Git operations',
      settings: [
        { key: 'alias.undo', label: 'Undo last commit (keep changes staged)', type: 'toggle', help: 'git undo — soft-resets HEAD by one commit so your changes stay in the staging area, ready to recommit' },
        { key: 'alias.nuke', label: 'Undo last commit (discard changes)', type: 'toggle', help: 'git nuke — hard-resets HEAD by one commit, permanently destroying uncommitted changes' },
        { key: 'alias.diff-main', label: 'Diff current branch vs main', type: 'toggle', help: 'git diff-main — shows all changes on your branch compared to where it diverged from main' },
        { key: 'alias.lg', label: 'Pretty log graph', type: 'toggle', help: 'git lg — compact, colored, one-line-per-commit graph of all branches' },
        { key: 'alias.who', label: 'Who changed this file?', type: 'toggle', help: 'git who <file> — shortlog showing all contributors to a file, sorted by number of commits' },
        { key: 'alias.recent', label: 'Recently worked-on branches', type: 'toggle', help: 'git recent — lists your 10 most recently checked-out branches, newest first' },
        { key: 'alias.wip', label: 'Quick work-in-progress commit', type: 'toggle', help: 'git wip — stages everything and creates a "WIP" commit you can amend or squash later' },
        { key: 'alias.unstage', label: 'Unstage files', type: 'toggle', help: 'git unstage <file> — removes files from the staging area without discarding changes' },
        { key: 'alias.amend', label: 'Amend last commit (no edit)', type: 'toggle', help: 'git amend — adds staged changes to the last commit without changing its message' },
        { key: 'alias.stash-all', label: 'Stash everything (incl. untracked)', type: 'toggle', help: 'git stash-all — stashes all changes including new untracked files' },
        { key: 'alias.aliases', label: 'List all your aliases', type: 'toggle', help: 'git aliases — prints all configured aliases so you don\'t forget what you set up' }
      ]
    },
    credentials: {
      label: 'Credentials & Signing',
      icon: '🔐',
      description: 'Authentication, credential storage, and commit verification',
      settings: [
        { key: 'credential.helper', label: 'Credential Helper', type: 'select', help: 'How Git stores your passwords and tokens', defaultValue: 'none', options: [
          { value: 'none', label: 'None — ask every time (default)' },
          { value: 'osxkeychain', label: 'macOS Keychain' },
          { value: 'manager', label: 'Git Credential Manager (Windows/cross-platform)' },
          { value: 'store', label: 'Store in plaintext file (less secure)' },
          { value: 'cache --timeout=3600', label: 'Cache in memory for 1 hour' },
          { value: 'cache --timeout=86400', label: 'Cache in memory for 24 hours' }
        ]},
        { key: 'commit.gpgsign', label: 'Sign All Commits', type: 'toggle', help: "Automatically sign every commit — gives you the 'Verified' badge on GitHub and GitLab" },
        { key: 'tag.gpgsign', label: 'Sign All Tags', type: 'toggle', help: 'Automatically sign every tag you create' },
        { key: 'gpg.format', label: 'Signing Format', type: 'select', help: 'Which signing method to use — SSH is simpler (uses your existing SSH key), GPG is traditional', defaultValue: 'openpgp', options: [
          { value: 'openpgp', label: 'GPG / OpenPGP (default)' },
          { value: 'ssh', label: 'SSH — use your SSH key (recommended, simpler setup)' }
        ]},
        { key: 'user.signingkey', label: 'Signing Key', type: 'text', placeholder: '~/.ssh/id_ed25519.pub or GPG key ID', help: 'Path to your SSH public key (if using SSH format) or your GPG key ID (if using GPG)' }
      ]
    },
    performance: {
      label: 'Performance',
      icon: '⚡',
      description: 'Speed optimizations for large repos',
      settings: [
        { key: 'core.fsmonitor', label: 'File System Monitor', type: 'toggle', help: 'Use OS file watcher for faster status — big speedup in large repos' },
        { key: 'core.untrackedCache', label: 'Untracked File Cache', type: 'toggle', help: 'Cache untracked file info to speed up git status' },
        { key: 'feature.manyFiles', label: 'Many Files Optimization', type: 'toggle', help: 'Enable optimizations for repos with many files' },
        { key: 'pack.threads', label: 'Pack Threads', type: 'select', help: 'Number of threads for packing operations', defaultValue: '1', options: [
          { value: '1', label: '1 thread (default)' },
          { value: '0', label: 'Auto-detect (use all cores)' },
          { value: '2', label: '2 threads' },
          { value: '4', label: '4 threads' }
        ]}
      ]
    }
  };

  var ALIAS_VALUES = {
    'alias.undo':      'reset --soft HEAD~1',
    'alias.nuke':      'reset --hard HEAD~1',
    'alias.diff-main': '!git diff $(git merge-base HEAD main)..HEAD',
    'alias.lg':        'log --oneline --graph --decorate --all --abbrev-commit',
    'alias.who':       'shortlog -s -n --all --no-merges --',
    'alias.recent':    "branch --sort=-committerdate --format='%(refname:short) (%(committerdate:relative))' --count=10",
    'alias.wip':       "!git add -A && git commit -m 'WIP'",
    'alias.unstage':   'restore --staged',
    'alias.amend':     'commit --amend --no-edit',
    'alias.stash-all': 'stash push --include-untracked',
    'alias.aliases':   'config --get-regexp ^alias\\\\.'
  };

  var PRESETS = {
    minimal: {
      label: 'Minimal', desc: 'Just the essentials',
      values: { 'init.defaultBranch': 'main', 'core.autocrlf': 'input', 'push.autoSetupRemote': true, 'pull.rebase': 'true' }
    },
    recommended: {
      label: 'Recommended', desc: 'Battle-tested defaults',
      values: {
        'init.defaultBranch': 'main', 'core.autocrlf': 'input', 'diff.algorithm': 'histogram',
        'diff.colorMoved': 'default', 'merge.conflictstyle': 'zdiff3', 'rerere.enabled': true,
        'rebase.autoSquash': true, 'rebase.autoStash': true, 'push.autoSetupRemote': true,
        'pull.rebase': 'true', 'fetch.prune': true, 'color.ui': 'auto', 'log.abbrevCommit': true,
        'alias.undo': true, 'alias.lg': true, 'alias.recent': true, 'alias.unstage': true, 'alias.amend': true
      }
    },
    performance: {
      label: 'Large Repo', desc: 'Optimized for big codebases',
      values: {
        'init.defaultBranch': 'main', 'core.autocrlf': 'input', 'diff.algorithm': 'histogram',
        'diff.colorMoved': 'default', 'merge.conflictstyle': 'zdiff3', 'rerere.enabled': true,
        'rebase.autoSquash': true, 'rebase.autoStash': true, 'rebase.updateRefs': true,
        'push.autoSetupRemote': true, 'pull.rebase': 'true', 'fetch.prune': true, 'color.ui': 'auto',
        'core.fsmonitor': true, 'core.untrackedCache': true, 'feature.manyFiles': true, 'pack.threads': '0'
      }
    }
  };

  /* ── Build default-values lookup ──────────────────────────────────── */

  var DEFAULT_VALUES = {};
  Object.keys(CONFIG_SECTIONS).forEach(function (sKey) {
    CONFIG_SECTIONS[sKey].settings.forEach(function (s) {
      if (s.type === 'select' && s.defaultValue !== undefined) {
        DEFAULT_VALUES[s.key] = s.defaultValue;
      }
    });
  });

  /* ── State ────────────────────────────────────────────────────────── */

  var values = {};
  var activeSection = 'identity';
  var copied = false;

  /* ── Helpers ──────────────────────────────────────────────────────── */

  function isNonDefault(key, val) {
    if (val === '' || val === false || val === undefined) return false;
    if (DEFAULT_VALUES[key] !== undefined && val === DEFAULT_VALUES[key]) return false;
    return true;
  }

  function countSettings() {
    var n = 0;
    Object.keys(values).forEach(function (k) { if (isNonDefault(k, values[k])) n++; });
    return n;
  }

  function sectionHasValues(sectionKey) {
    var settings = CONFIG_SECTIONS[sectionKey].settings;
    for (var i = 0; i < settings.length; i++) {
      if (isNonDefault(settings[i].key, values[settings[i].key])) return true;
    }
    return false;
  }

  function generateConfig() {
    var lines = [
      '# Git Config Generator – Generated by Tower (https://www.git-tower.com)',
      '# ' + new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
      ''
    ];
    var grouped = {};

    Object.keys(values).forEach(function (key) {
      var val = values[key];
      if (!isNonDefault(key, val)) return;

      var parts = key.split('.');
      var section = parts[0];
      var subkey = parts.slice(1).join('.');
      if (!grouped[section]) grouped[section] = [];

      var outputVal = val;
      if (key.indexOf('alias.') === 0 && val === true) {
        outputVal = ALIAS_VALUES[key] || val;
      } else if (val === true) {
        outputVal = 'true';
      }
      grouped[section].push({ subkey: subkey, value: outputVal });
    });

    Object.keys(grouped).forEach(function (section) {
      lines.push('[' + section + ']');
      grouped[section].forEach(function (e) {
        lines.push('\t' + e.subkey + ' = ' + e.value);
      });
      lines.push('');
    });

    return lines.length > 3 ? lines.join('\n') : '';
  }

  function syntaxHighlight(text) {
    return text.split('\n').map(function (line) {
      if (line.charAt(0) === '#') return '<div class="line-comment">' + esc(line) + '</div>';
      if (line.charAt(0) === '[') return '<div class="line-section">' + esc(line) + '</div>';
      var eqIdx = line.indexOf('=');
      if (eqIdx > -1) {
        return '<div><span class="line-key">' + esc(line.substring(0, eqIdx)) +
          '</span><span class="line-eq">=</span><span class="line-value">' +
          esc(line.substring(eqIdx + 1)) + '</span></div>';
      }
      return '<div>' + esc(line) + '</div>';
    }).join('');
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function copyToClipboard() {
    var output = generateConfig();
    navigator.clipboard.writeText(output).then(function () {
      copied = true;
      updateCopyButtons();
      setTimeout(function () { copied = false; updateCopyButtons(); }, 2000);
    });
  }

  function downloadFile() {
    var output = generateConfig();
    var blob = new Blob([output], { type: 'text/plain' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = '.gitconfig';
    a.click();
    URL.revokeObjectURL(url);
  }

  /* ── Rendering ────────────────────────────────────────────────────── */

  var root;

  function render() {
    if (!root) return;

    var output = generateConfig();
    var count = countSettings();
    var hasOutput = !!output;

    // Badge
    var badge = root.querySelector('.cfg-badge');
    badge.textContent = count + ' setting' + (count !== 1 ? 's' : '');
    badge.classList.toggle('is-visible', count > 0);

    // Header export buttons — show/hide based on whether there's output
    root.querySelector('.cfg-header__export').classList.toggle('is-visible', hasOutput);

    // Nav buttons
    var navBtns = root.querySelectorAll('.cfg-nav-btn');
    navBtns.forEach(function (btn) {
      var key = btn.dataset.section;
      btn.classList.toggle('is-active', key === activeSection);
      btn.querySelector('.cfg-nav-btn__label').style.fontWeight = key === activeSection ? '600' : '400';
      var dot = btn.querySelector('.cfg-nav-btn__dot');
      dot.classList.toggle('is-visible', sectionHasValues(key));
    });

    // Generate button
    root.querySelector('.cfg-btn-generate').disabled = !hasOutput;

    // Main content — skip rebuild if a text input has focus (avoids losing cursor)
    var activeEl = document.activeElement;
    if (!activeEl || !activeEl.classList.contains('cfg-input')) {
      renderSection();
    }

    updateCopyButtons();
  }

  function renderSection() {
    var container = root.querySelector('.cfg-settings-list');
    var section = CONFIG_SECTIONS[activeSection];

    // Header
    root.querySelector('.cfg-section-header h2').innerHTML =
      '<span>' + section.icon + '</span>' + esc(section.label);
    root.querySelector('.cfg-section-header p').textContent = section.description;

    // Settings
    container.innerHTML = '';
    section.settings.forEach(function (setting) {
      if (setting.key.indexOf('alias.') === 0) {
        container.appendChild(buildAliasRow(setting));
      } else {
        container.appendChild(buildSettingRow(setting));
      }
    });
  }

  function buildToggle(key) {
    var btn = document.createElement('button');
    btn.className = 'cfg-toggle' + (values[key] ? ' is-on' : '');
    btn.type = 'button';
    btn.innerHTML = '<span class="cfg-toggle__knob"></span>';
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      values[key] = !values[key];
      if (!values[key]) delete values[key];
      render();
    });
    return btn;
  }

  function buildSettingRow(setting) {
    var row = document.createElement('div');
    row.className = 'cfg-setting';

    var helpVisible = false;

    // Info side
    var info = document.createElement('div');
    info.className = 'cfg-setting__info';

    var labelRow = document.createElement('div');
    labelRow.className = 'cfg-setting__label-row';

    var label = document.createElement('span');
    label.className = 'cfg-setting__label';
    label.textContent = setting.label;

    var helpBtn = document.createElement('button');
    helpBtn.className = 'cfg-setting__help-btn';
    helpBtn.type = 'button';
    helpBtn.textContent = '?';
    helpBtn.title = setting.help;

    var helpText = document.createElement('div');
    helpText.className = 'cfg-setting__help-text';
    helpText.innerHTML = esc(setting.help) + '<span class="cfg-setting__help-key">' + esc(setting.key) + '</span>';

    helpBtn.addEventListener('click', function () {
      helpVisible = !helpVisible;
      helpText.classList.toggle('is-visible', helpVisible);
      helpBtn.classList.toggle('is-active', helpVisible);
    });

    labelRow.appendChild(label);
    labelRow.appendChild(helpBtn);
    info.appendChild(labelRow);
    info.appendChild(helpText);

    // Control side
    var control = document.createElement('div');
    control.className = 'cfg-setting__control';

    if (setting.type === 'toggle') {
      control.appendChild(buildToggle(setting.key));
    } else if (setting.type === 'select') {
      var select = document.createElement('select');
      select.className = 'cfg-select';
      setting.options.forEach(function (opt) {
        var o = document.createElement('option');
        o.value = opt.value;
        o.textContent = opt.label;
        select.appendChild(o);
      });
      select.value = values[setting.key] || setting.defaultValue || '';
      select.addEventListener('change', function () {
        values[setting.key] = select.value;
        render();
      });
      control.appendChild(select);
    } else if (setting.type === 'text') {
      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'cfg-input';
      input.placeholder = setting.placeholder || '';
      input.value = values[setting.key] || '';
      input.addEventListener('input', function () {
        if (input.value) {
          values[setting.key] = input.value;
        } else {
          delete values[setting.key];
        }
        render();
      });
      control.appendChild(input);
    }

    row.appendChild(info);
    row.appendChild(control);
    return row;
  }

  function buildAliasRow(setting) {
    var cmd = ALIAS_VALUES[setting.key] || '';
    var aliasName = setting.key.replace('alias.', '');
    var isActive = !!values[setting.key];

    var row = document.createElement('div');
    row.className = 'cfg-alias' + (isActive ? ' is-active' : '');

    row.addEventListener('click', function () {
      values[setting.key] = !values[setting.key];
      if (!values[setting.key]) delete values[setting.key];
      render();
    });

    var toggleWrap = document.createElement('div');
    toggleWrap.className = 'cfg-alias__toggle-wrap';
    toggleWrap.appendChild(buildToggle(setting.key));

    var content = document.createElement('div');
    content.className = 'cfg-alias__content';

    var cmdRow = document.createElement('div');
    cmdRow.className = 'cfg-alias__command-row';
    cmdRow.innerHTML =
      '<code class="cfg-alias__name">git ' + esc(aliasName) + '</code>' +
      '<code class="cfg-alias__value">git ' + esc(cmd) + '</code>';

    var desc = document.createElement('div');
    desc.className = 'cfg-alias__desc';
    desc.textContent = setting.help;

    content.appendChild(cmdRow);
    content.appendChild(desc);
    row.appendChild(toggleWrap);
    row.appendChild(content);
    return row;
  }

  function updateCopyButtons() {
    var headerCopy = root.querySelector('.cfg-btn-copy-header');
    var lgCopy = root.querySelector('.cfg-btn-copy-lg');
    if (headerCopy) {
      headerCopy.textContent = copied ? 'Copied!' : 'Copy';
      headerCopy.classList.toggle('is-copied', copied);
    }
    if (lgCopy) {
      lgCopy.textContent = copied ? 'Copied to Clipboard!' : 'Copy to Clipboard';
      lgCopy.classList.toggle('is-copied', copied);
    }
  }

  /* ── Init ─────────────────────────────────────────────────────────── */

  function init(selector) {
    root = document.querySelector(selector);
    if (!root) return;

    buildSkeleton();
    bindEvents();
    render();
  }

  function buildSkeleton() {
    root.classList.add('cfg-generator');
    root.innerHTML = [
      // Header
      '<header class="cfg-header">',
      '  <div>',
      '    <h1 class="cfg-header__title">Git Config Generator</h1>',
      '    <p class="cfg-header__subtitle">Build your perfect <code>.gitconfig</code> — no manual editing needed</p>',
      '  </div>',
      '  <div class="cfg-header__actions">',
      '    <span class="cfg-badge"></span>',
      '    <div class="cfg-header__export">',
      '      <button class="cfg-btn-copy-header" type="button">Copy</button>',
      '      <button class="cfg-btn-download-header" type="button">Download</button>',
      '    </div>',
      '    <button class="cfg-btn-reset" type="button">Reset</button>',
      '  </div>',
      '</header>',

      '<div class="cfg-layout">',

      // Quick Presets bar
      '  <div class="cfg-presets-bar">',
      '    <span class="cfg-presets-bar__label">Quick Presets</span>',
      '    <div class="cfg-preset-list">' + buildPresetButtons() + '</div>',
      '  </div>',

      '  <div class="cfg-layout__body">',

      // Sidebar
      '  <nav class="cfg-sidebar">',
      '    <div class="cfg-sidebar__sections">',
      '      <div class="cfg-sidebar__label">Sections</div>',
      buildNavButtons(),
      '    </div>',
      '    <div class="cfg-sidebar__generate">',
      '      <button class="cfg-btn-generate" type="button">Generate Config</button>',
      '    </div>',
      '  </nav>',

      // Main
      '  <main class="cfg-main">',
      '    <div class="cfg-section-header"><h2></h2><p></p></div>',
      '    <div class="cfg-settings-list"></div>',
      '  </main>',

      '  </div>', // end .cfg-layout__body

      '</div>',

      // Modal
      '<div class="cfg-modal-overlay is-hidden">',
      '  <div class="cfg-modal">',
      '    <div class="cfg-modal__header">',
      '      <div>',
      '        <h3 class="cfg-modal__title">Your very own .gitconfig</h3>',
      '        <p class="cfg-modal__subtitle">Copy this to <code>~/.gitconfig</code> or download the file and rename it to <code>.gitconfig</code></p>',
      '      </div>',
      '      <button class="cfg-modal__close" type="button">✕</button>',
      '    </div>',
      '    <pre class="cfg-modal__code"></pre>',
      '    <div class="cfg-modal__actions">',
      '      <button class="cfg-btn-copy-lg" type="button">Copy to Clipboard</button>',
      '      <button class="cfg-btn-download-lg" type="button">Download file</button>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');
  }

  function buildPresetButtons() {
    return Object.keys(PRESETS).map(function (key) {
      var p = PRESETS[key];
      return '<button class="cfg-preset-btn" type="button" data-preset="' + key + '">' +
        '<div class="cfg-preset-btn__name">' + esc(p.label) + '</div>' +
        '<div class="cfg-preset-btn__desc">' + esc(p.desc) + '</div>' +
        '</button>';
    }).join('');
  }

  function buildNavButtons() {
    return Object.keys(CONFIG_SECTIONS).map(function (key) {
      var s = CONFIG_SECTIONS[key];
      return '<button class="cfg-nav-btn" type="button" data-section="' + key + '">' +
        '<span class="cfg-nav-btn__icon">' + s.icon + '</span>' +
        '<span class="cfg-nav-btn__label">' + esc(s.label) + '</span>' +
        '<span class="cfg-nav-btn__dot"></span>' +
        '</button>';
    }).join('');
  }

  function bindEvents() {
    // Reset
    root.querySelector('.cfg-btn-reset').addEventListener('click', function () {
      values = {};
      render();
    });

    // Presets
    root.querySelectorAll('.cfg-preset-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        values = JSON.parse(JSON.stringify(PRESETS[btn.dataset.preset].values));
        render();
      });
    });

    // Section nav
    root.querySelectorAll('.cfg-nav-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeSection = btn.dataset.section;
        render();
      });
    });

    // Generate button → open modal
    root.querySelector('.cfg-btn-generate').addEventListener('click', function () {
      var output = generateConfig();
      root.querySelector('.cfg-modal__code').textContent = output;
      root.querySelector('.cfg-modal-overlay').classList.remove('is-hidden');
    });

    // Modal close
    root.querySelector('.cfg-modal__close').addEventListener('click', closeModal);
    root.querySelector('.cfg-modal-overlay').addEventListener('click', function (e) {
      if (e.target === e.currentTarget) closeModal();
    });

    // Copy & Download — header
    root.querySelector('.cfg-btn-copy-header').addEventListener('click', copyToClipboard);
    root.querySelector('.cfg-btn-download-header').addEventListener('click', downloadFile);

    // Copy & Download — modal
    root.querySelector('.cfg-btn-copy-lg').addEventListener('click', copyToClipboard);
    root.querySelector('.cfg-btn-download-lg').addEventListener('click', downloadFile);
  }

  function closeModal() {
    root.querySelector('.cfg-modal-overlay').classList.add('is-hidden');
  }

  /* ── Public API ───────────────────────────────────────────────────── */

  window.GitConfigGenerator = { init: init };

})();
